<div class="pieces-group-wrapper"
     (click)="onProductTypeClick($event)">
  <div class="p-3 d-flex justify-content-start align-items-center">
    @if (showImage && !!productType.image) {
      <product-image class="me-3"
                     data-modal-ignore
                     [imagePreviewTrigger]="productType.image.original">
        <img class="product-image" [src]="productType.image.small" [alt]="productType.name">
      </product-image>
    }
    <div>
      <div class="fw-super-bold">{{ productType?.name }}</div>
      @if (productType.minQuantity > 1 || productType.maxQuantity || stockLeft !== null || dailyLimit !== null) {
        <product-quantity-info
          [min]="productType.minQuantity"
          [max]="productType.maxQuantity"
          [stockLeft]="stockLeft"
          [dailyLimit]="dailyLimit"
          [unitKey]="size?.details?.unit?.key"
          [cssClass]="'text-muted font-md'"
        ></product-quantity-info>
      }

      <product-availability-info
        [availability]="productType?.availability"
        [cssClass]="'font-md mt-1'"
      ></product-availability-info>
    </div>
  </div>

  @for (product of products; track product.id) {
    @let totals = variantTotalsById[product.variant.id];
    @let isMultiBuild = isVariantMultiBuild(product.variant.id);

    <product-card class="d-block px-3 py-2"
                  [class.cart-line-in-cart]="!!totals?.count">
      <product-header class="d-flex justify-content-between align-items-start">
        <div class="fw-bold w-60">{{ product.variant.name }}</div>

        @if (!totals?.count) {
          <div class="d-flex align-items-center"
               data-modal-ignore>
            <product-price [price]="product.price"
                           [discount]="productType.discount?.value"
                           [currency]="productType?.bakery?.country?.currencySymbol"
                           [perUnitText]="('cakeBuilder.sizeUnits.unitType.' + size?.details?.unit?.key) | translate">
            </product-price>

            <button class="ms-2 pointer btn-primary-themed add-to-cart-btn"
                    [disabled]="isAddToCartDisabled"
                    (click)="onAddToCartClick(product.id)">
              <i class="icon-plus add-to-cart-icon"></i>
            </button>
          </div>
        }
      </product-header>

      @if (!!totals?.count) {
        <product-counter data-modal-ignore>
          <!-- in several builds: one counter can't tell which build to change, so only the cart actions -->
          @if (!isMultiBuild) {
            <ui-multiple-variants-counter
              counter
              [step]="productType.increment"
              [minCount]="0"
              [minCountPerProduct]="productType.minQuantityPerProduct"
              [count]="totals.count"
              [size]="'xs'"
              [isPlusDisabled]="plusDisabledById[product.variant.id]"
              [btnHighlighting]="totals.count > 0"
              [btnStyle]="'btn-pink'"
              [isAllowEnterCounter]="false"
              [calcProductCount]="calcProductCountWrapper(product.variant.id, totals.count || 0)"
              (onCountUpdated)="countUpdate(product.id, $event)">
            </ui-multiple-variants-counter>
          }

          @if (!isMultiBuild) {
            <div price class="fw-bold text-center mt-1">
              {{ totals.price | currencyFormat: productType?.bakery?.country?.currencySymbol }}
            </div>
          }

          <product-cart-actions
            actions
            [buildsCount]="totals.buildsCount"
            [totalCount]="totals.count"
            [showEdit]="shouldShowModalOnAdd"
            [showAddNew]="shouldShowModalOnAdd"
            (edit)="onEditVariant(product.variant.id)"
            (addNew)="onAddNew()"
            (showCart)="onShowCart()"
          ></product-cart-actions>
        </product-counter>
      }

      <product-description>
        @if (!uiContext.isXs()) {
          <div class="font-sm text-muted"
               [innerHTML]="product.variant.description">
          </div>
        } @else {
          <product-description-slice
            class="font-sm text-muted"
            [lines]="2"
            [text]="product.variant.description"
          ></product-description-slice>
        }
      </product-description>
    </product-card>
  }
</div>
